import React from 'react';
import NavBar from './components/Header/Navbar';
import Home from './components/Home/Home';

const App = () => {
  return (
    <div className="main">
    <NavBar></NavBar>
      <Home></Home>
    </div>
  );
};

export default App;